/* Storefront conversion only, after explicit buyer action. No Recharge contract API. */
(() => {
  if (customElements.get('lf-one-time-cart-line')) return;
  class OneTimeCartLine extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('[data-convert-one-time]').addEventListener('click', () => this.convert());
    }

    async convert() {
      if (this.busy) return;
      this.busy = true;
      const button = this.querySelector('[data-convert-one-time]');
      const status = this.querySelector('[data-convert-status]');
      button.disabled = true;
      status.textContent = 'Updating your cart…';
      try {
        const cartUrl = window.routes.cart_url;
        const read = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!read.ok) throw new Error('Unable to read your cart. Please try again.');
        const cart = await read.json();
        const line = cart.items.find((item) => item.key === this.dataset.lineKey);
        // A stale line must not be matched by variant: mixed carts can have both purchase types.
        if (!line) throw new Error('Your cart changed. Refresh this page and try again.');
        if (!line.selling_plan_allocation) {
          window.location.assign(cartUrl);
          return;
        }
        const response = await fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: null })
        });
        const updated = await response.json();
        if (!response.ok || updated.errors || updated.status) {
          throw new Error(updated.description || 'Unable to update your cart. Please try again.');
        }
        // Full reload refreshes line keys, tier discounts, totals, drawer and checkout availability together.
        window.location.assign(cartUrl);
      } catch (error) {
        status.textContent = error.message || 'Unable to update your cart. Please try again.';
        button.disabled = false;
        this.busy = false;
      }
    }
  }
  customElements.define('lf-one-time-cart-line', OneTimeCartLine);
})();
